import { InjectionToken } from "@angular/core";
import { ICloudCreateUpdateModalService } from "./i-cloud-create-update-modal.service";

export const cloudCreateUpdateModalServiceInjectionToken: InjectionToken<ICloudCreateUpdateModalService> = new InjectionToken<ICloudCreateUpdateModalService>("digital-signage.user-dashboard.dashboard-web.CloudCreateUpdateModalService");
